import { useDispatch } from 'react-redux';
import { alert, close as closeAction } from '../actions';

const useAlert = () => {
  const dispatch = useDispatch();

  function open(
    payload = {
      title: null,
      content: null,
      actions: { left: null, right: null }
    }
  ) {
    dispatch(alert(payload));
  }

  function close() {
    dispatch(closeAction());
  }

  return [open, close];
};

export default useAlert;
